import { observer } from 'mobx-react-lite';

import { ModalsManager } from '@/components/modals/modalsManager';
import { Button, XStack } from '@/components/ui';
import { FEATURES, hasFeature } from '@/features/feature-flags';
import { AddIntegrationsModal } from '@/features/integrations/add-integrations-modal';
import { getIntegrationIcon } from '@/integrations/integration-icons';
import { uiStore } from '@/stores/ui.store';
import { AppCapability, isCapable } from '@/utils/capabilities';

import {
  CALENDAR_TOOLKIT,
  GMAIL_TOOLKIT,
  MORE_APPS,
} from '../../onboarding-web/feed/feed-onboarding.config';

const CONNECT_APP_TOOLKITS = [
  GMAIL_TOOLKIT,
  CALENDAR_TOOLKIT,
  ...MORE_APPS.map((app) => app.toolkitName),
];

export const useShowsConnectAppsCard = () =>
  isCapable(AppCapability.WebOnboarding) &&
  hasFeature(FEATURES.WEB_ONBOARDING_FEED) &&
  hasFeature(FEATURES.FEED_CONNECT_APPS_CARD) &&
  !uiStore.connectAppsCardDone;

export const ConnectAppsFeedCard = observer(() => {
  const connect = () => {
    uiStore.setConnectAppsCardDone(true);
    ModalsManager.show(AddIntegrationsModal, {});
  };

  return (
    <XStack className="min-w-0 items-center gap-3 rounded-xl border border-border bg-[var(--card-tile)] px-4 py-3 dark:bg-surface">
      <XStack className="shrink-0 items-center">
        {CONNECT_APP_TOOLKITS.map((toolkitName, index) => {
          const Icon = getIntegrationIcon(toolkitName);
          return (
            <span
              key={toolkitName}
              className={`flex size-7 shrink-0 items-center justify-center rounded-md border border-border bg-surface ${index > 0 ? '-ml-2' : ''}`}
            >
              <Icon className="size-4" />
            </span>
          );
        })}
      </XStack>
      <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground">
        See more apps in your feed
      </span>
      <XStack className="ml-auto shrink-0 items-center gap-1">
        <Button variant="secondary" size="xs" textSize="xs" onClick={connect}>
          Connect
        </Button>
        <Button
          variant="ghost"
          size="xs"
          textSize="xs"
          className="text-foreground-muted hover:text-foreground"
          onClick={() => uiStore.setConnectAppsCardDone(true)}
        >
          Dismiss
        </Button>
      </XStack>
    </XStack>
  );
});
